import { Helmet } from 'react-helmet-async';

const SITE_URL = (
    process.env.REACT_APP_SITE_URL ||
    (typeof window !== 'undefined' ? window.location.origin : '')
).replace(/\/+$/, '');

function absoluteUrl(path) {
    if (!path) return SITE_URL || '';
    if (/^https?:\/\//i.test(path)) return path;
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${SITE_URL}${p}`;
}

export default function Seo({
    title,
    description,
    canonical,
    ogImage,
    type = 'website',
    structuredData,
}) {
    const fullTitle = title
        ? `${title} — UtilityTool`
        : 'UtilityTool — Fast, private online utility tools';
    const desc =
        description ||
        'Fast, private online tools for everyday work: convert Word to PDF, compress images, and more. No signup required.';
    const canonicalHref = absoluteUrl(canonical || (typeof window !== 'undefined' ? window.location.pathname : '/'));
    const ogImageAbs = ogImage ? absoluteUrl(ogImage) : null;
    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={canonicalHref} />
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={canonicalHref} />
            {ogImageAbs ? <meta property="og:image" content={ogImageAbs} /> : null}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            {ogImageAbs ? <meta name="twitter:image" content={ogImageAbs} /> : null}
            {structuredData ? (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            ) : null}
        </Helmet>
    );
}
